"use client";
import { useState, useEffect } from "react";
import MapOrder from "../../services/map/mapOrder";
import { useGetAllOrdersQuery } from "../../services/order/orderServices";
import Header from "./../Header";
import styles from "./Map.module.css";

const OrderMapDialog = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [queryParams, setQueryParams] = useState({
    exclude_type: "Service",
  });

  // Define delivery status options
  const deliveryStatusOptions = [
    { name: "Need to Deliver", code: "Need to Deliver" },
    { name: "Took Trees", code: "Took Trees" },
    { name: "Picking Up", code: "Picking Up" },
    { name: "Delivery Schedule", code: "Delivery Schedule" },
    { name: "Delivery Scheduled", code: "Delivery Scheduled" }, // Added this from your original filter
    { name: "Delivered", code: "Delivered" },
    { name: "Tiki Bar Rental", code: "Tiki Bar Rental" },
    { name: "Cancelled", code: "Cancelled" },
  ];

  // API call with current query parameters
  const { data, isLoading, error, refetch } = useGetAllOrdersQuery(
    queryParams,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  // Handle filter changes from the MapOrder component
  const handleFilterChange = (newFilters) => {
    setQueryParams({
      ...queryParams,
      ...newFilters,
    });
  };

  useEffect(() => {
    const filterData = () => {
      let orders = [];

      if (!data?.data) return;

      // Get array of valid status codes
      const validStatusCodes = deliveryStatusOptions.map(
        (option) => option.code
      );

      data.data.forEach((order) => {
        // Parse the order date (format: MM/DD/YYYY)
        const orderDateParts = order.order_date
          ? order.order_date.split("/")
          : null;

        if (orderDateParts && orderDateParts.length === 3) {
          const orderDate = new Date(
            parseInt(orderDateParts[2]), // Year
            parseInt(orderDateParts[0]) - 1, // Month (0-indexed)
            parseInt(orderDateParts[1]) // Day
          );

          // Check if date is after February 2025 (February is month index 1)
          const isAfterFeb2025 = orderDate >= new Date(2025, 1, 28);

          // Check if order matches delivery status criteria and date criteria
          if (
            isAfterFeb2025 &&
            validStatusCodes.includes(order.order_delivery?.delivery_status)
          ) {
            orders.push(order);
          }
        }
      });

      setFilteredData(orders);
    };

    filterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error, refetch]);

  return (
    <>
      <div className={`${styles.fontFamily} h-screen py-4 pr-4`}>
        <div className="p-4 rounded-3xl h-full bg-[#ffeded]">
          <div className="flex flex-col justify-between h-full">
            <Header title={"Orders"} />
            <div className="flex justify-center">
              <MapOrder
                isLoading={isLoading}
                orderData={{
                  data: filteredData,
                  allOrderData: data,
                  refetchdata: refetch,
                }}
                onFilterChange={handleFilterChange}
                deliveryStatusOptions={deliveryStatusOptions}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderMapDialog;
